// extracted by mini-css-extract-plugin
export default {"header":"Header_header__s052a","main-image":"Header_main-image__fBxwQ"};